import { FloatingButtonVariantType } from '../../../../../../components/floatingButton/types/floatingButtonVariantType';
import { DotSizeType, DotVariantType } from '../../dot/variants';
export const getDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [FloatingButtonVariantType.DEFAULT]: {
            rootContainer: {
                position: 'relative',
                width: FOUNDATIONS.size_575,
                height: FOUNDATIONS.size_575,
                display: 'flex',
                justify_content: 'center',
                align_items: 'center',
                flex_shrink: '0',
                border_radius: FOUNDATIONS.radius_1000,
                border: `solid ${FOUNDATIONS.border_50} ${FOUNDATIONS.color_comp_actions_floatingbutton_border}`,
                background_color: FOUNDATIONS.color_comp_actions_floatingbutton_bg,
                box_shadow: SHADOWS.shadow_200,
                cursor: 'pointer',
            },
            icon: {
                width: FOUNDATIONS.size_450,
                height: FOUNDATIONS.size_450,
                color: FOUNDATIONS.color_comp_actions_floatingbutton_icon,
            },
            dotContainer: {
                position: 'absolute',
                right: '11px',
                top: '11px',
                pointer_events: 'none',
            },
            dot: {
                variant: DotVariantType.REGULAR,
                size: DotSizeType.MEDIUM,
            },
        },
    };
};
//# sourceMappingURL=default.js.map